import { Box, Divider, FillPreview, Text } from '@wix/design-system';
import { MoreSmall } from '@wix/wix-ui-icons-common';
import React from 'react';

import { SWATCH_TOGGLE } from './../../color-picker/button-color-swatches/data-hooks';

import { SingleColorSwatch } from '../new-color-picker/components/single-color-swatch';
import classes from './button-color-swatches-scss';

type ButtonColorSwatchesProps = {
  label: string;
  color: string | undefined;
  onChange: (color: string) => void;
  dataHook: string;
  defaultColor?: string;
  onMorePress: () => void;
  moreButtonRef: React.Ref<HTMLDivElement>;
};

const SWATCH_COLORS = ['#000624', '#25A55A', '#FFB700', '#E62214', '#116DFF'];

export const ButtonColorSwatches: React.FC<ButtonColorSwatchesProps> = ({
  label,
  color,
  onChange,
  dataHook,
  defaultColor,
  onMorePress,
  moreButtonRef,
}) => {
  return (
    <Box gap="SP3" direction="vertical" dataHook={dataHook}>
      <Text size="small">{label}</Text>
      <Box display="flex" width="100%" alignContent="stretch" gap="SP3">
        {SWATCH_COLORS.map(c => (
          <SingleColorSwatch
            key={c}
            fill={c}
            selectedColor={color || defaultColor}
            onClick={onChange}
            className={classes.fillPreview}
          />
        ))}
        <Divider direction="vertical" className={classes.divider} />
        <FillPreview
          fill={<MoreSmall />}
          className={classes.fillPreview}
          onClick={onMorePress}
          ref={moreButtonRef}
          dataHook={SWATCH_TOGGLE}
        />
      </Box>
    </Box>
  );
};
